import React from 'react';
import { Badge } from "@mui/material";
import CircleIcon from '@mui/icons-material/Circle';
import { makeStyles } from "@mui/styles";

const FilterWrapper: React.FC<FilterWrapperProps> = props => {
    const styles = useStyles();

    return (
        <Badge
            invisible={ !props.used }
            badgeContent={
                <CircleIcon
                    fontSize='small'
                    className={ styles.icon }
                    style={ { marginLeft: props.position === 'left' ? '5px' : '-5px' } }
                />
            }
            title={ props.used ? 'Ten filtr jest aktywny' : undefined }
            className={ styles.root }
            anchorOrigin={ {
                vertical: 'top',
                horizontal: props.position || 'right',
            } }
        >
            { props.children }
        </Badge>
    );
}
export default FilterWrapper;

export interface FilterWrapperProps {
    readonly used: boolean;
    readonly children?: React.ReactNode;
    readonly position?: 'left' | 'right';
}

const useStyles = makeStyles(theme => ({
    root: {
        width: 'inherit'
    },
    icon: {
        marginTop: '3px',
        color: theme.palette.secondary.main,
        fontSize: '14px'
    }
}));